import React from "react";
import {
  GET_ALL_CATEGORIES,
  STORE_CATEGORY,
  UPDATE_CATEGORY,
  DELETE_CATEGORY,
  INDEX_CATEGORIES,
} from "../../types";
export default function CategoriesReducer(state, action) {
  switch (action.type) {
    case GET_ALL_CATEGORIES:
      return {
        ...state,
        categories: action.payload,
        success: false,
        ErrorsApi: [],
      };

    case STORE_CATEGORY:
      return {
        ...state,
        categories: [action.payload, ...state.categories],
      };
    case UPDATE_CATEGORY:
      return {
        ...state,
        ErrorsAPI: [],
        categories: state.categories.map((product) =>
          product.id === action.payload.id ? { ...action.payload } : product
        ),
      };
    case DELETE_CATEGORY:
      return {
        ...state,
        categories: state.categories.filter(
          (category) => category.id !== action.payload
        ),
      };
    default:
      return state;
  }
}
